import { render, staticRenderFns } from "./WeeklyTemplate.vue?vue&type=template&id=e175fb3a&"
import script from "./WeeklyTemplate.vue?vue&type=script&lang=ts&"
export * from "./WeeklyTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports